module.exports = __webpack_public_path__ + "media/Zecon Animação Push.63c264fd.mp4";